// client/src/components/layout/Footer.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../hooks/useSettings.js';

const CONTACT_EMAIL = 'thecherryfairies@gmail.com';

export default function Footer() {
  const { settings } = useSettings();
  const year = new Date().getFullYear();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers / insecure contexts
      const input = document.createElement('input');
      input.value = CONTACT_EMAIL;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <footer className="bg-royal-900 border-t border-royal-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-display text-gold text-lg mb-3">{settings.site_name || 'Fairytale'}</h3>
            <p className="text-royal-100 text-sm font-body">
              Spreading magic one Moonbeam at a time.
            </p>
          </div>

          <div>
            <h4 className="text-royal-100 font-semibold mb-3 text-sm">Explore</h4>
            <div className="space-y-2">
              <Link to="/moonbeams" className="block text-sm text-royal-200 hover:text-gold transition-colors">
                {settings.cards_display_name || 'Moonbeams'}
              </Link>
              <Link to="/stories" className="block text-sm text-royal-200 hover:text-gold transition-colors">
                {settings.stories_display_name || 'Stories'}
              </Link>
              <Link to="/pricing" className="block text-sm text-royal-200 hover:text-gold transition-colors">
                Pricing
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-royal-100 font-semibold mb-3 text-sm">Account</h4>
            <div className="space-y-2">
              <Link to="/login" className="block text-sm text-royal-200 hover:text-gold transition-colors">
                Login
              </Link>
              <Link to="/register" className="block text-sm text-royal-200 hover:text-gold transition-colors">
                Register
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-royal-100 font-semibold mb-3 text-sm">Contact Us</h4>
            <p className="text-royal-100 text-sm font-body mb-3">
              Have a question, a kind word, or a fairy sighting to report? We'd love to hear from you.
            </p>
            <div className="flex items-center gap-2">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="text-sm text-royal-200 hover:text-gold transition-colors break-all"
              >
                {CONTACT_EMAIL}
              </a>
              <button
                type="button"
                onClick={handleCopy}
                aria-label="Copy email address"
                title={copied ? 'Copied!' : 'Copy email'}
                className="shrink-0 text-royal-200 hover:text-gold transition-colors"
              >
                {copied ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                )}
              </button>
            </div>
            {copied && (
              <span className="text-gold text-xs mt-1 block">Copied to clipboard!</span>
            )}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-royal-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-royal-200 text-sm">
              &copy; {year} {settings.site_name || 'Fairytale'}. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
              <Link to="/privacy" className="text-royal-200 text-sm hover:text-gold transition-colors">
                Privacy Policy
              </Link>
              <span className="text-royal-200 text-sm">·</span>
              <Link to="/terms" className="text-royal-200 text-sm hover:text-gold transition-colors">
                Terms of Service
              </Link>

              {/* SWEEPSTAKES — safe to delete this span + Link after October 27, 2026.
                  Leave the /rules route and Rules.js in place so existing links still resolve. */}
              <span className="text-royal-200 text-sm">·</span>
              <Link to="/rules" className="text-royal-200 text-sm hover:text-gold transition-colors">
                Sweepstakes Official Rules
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}